import { fromEquals } from 'fp-ts/lib/Eq';
import { Node } from '../generated/graphql';

export const getEqNode = <T extends Node>() =>
  fromEquals<T>((x, y) => x.id === y.id);
